module.exports = __webpack_public_path__ + "static/media/folder_color-6.f0684065.svg";